import request from '../index';

export const getSingleSeries = (seriesId) =>
  request({
    url: `/movies/personalized_movie_index/subseries/${seriesId}`,
    method: 'GET',
  });

export const getSingleSeriesInfo = (seriesId) =>
  request({
    url: `/movies/${seriesId}`,
    method: 'GET',
  });

export const addWatchListSeries = (serieId) =>
  request({
    url: 'watchlist_subseries/add',
    method: 'POST',
    data: { ids: [serieId] },
  });

export const removeWatchlistSeries = (serieId) =>
  request({
    url: 'watchlist_subseries/remove',
    method: 'POST',
    data: { ids: [serieId] },
  });
